export const locations = {
  home: '/',
  signIn: '/sign-in',
  loggedInRedirect: '/projects',
  projects: '/projects',
  search: '/search',
  trainingsUuid: (executionUuid: string) =>
    `/trainings?execution_uuid=${executionUuid}`,
  products: (projectId: number) => `/projects/${projectId}/products`,
  trainings: (projectId: number, productId: number, trainingId?: number) =>
    `/projects/${projectId}/products/${productId}/trainings${
      trainingId ? `#${trainingId}` : ''
    }`,
  training: (projectId: number, productId: number, trainingId: number) =>
    `/projects/${projectId}/products/${productId}/trainings/${trainingId}`,
  trainingNew: (projectId: number, productId: number) =>
    `/projects/${projectId}/products/${productId}/new-training`,
  trainingAnnotation: (
    projectId: number,
    productId: number,
    trainingId: number
  ) =>
    `/training/${trainingId}/annotation?projectId=${projectId}&productId=${productId}`,
  images: (projectId: number, productId: number) =>
    `/projects/${projectId}/products/${productId}/images`,
  datasets: (projectId: number, productId: number) =>
    `/projects/${projectId}/products/${productId}/datasets`,
  datasetNew: (projectId: number, productId: number) =>
    `/projects/${projectId}/products/${productId}/dataset`,
  datasetEdit: (projectId: number, productId: number, datasetId: number) =>
    `/projects/${projectId}/products/${productId}/dataset/${datasetId}`,
  trainingTest: (
    projectId: number,
    productId: number,
    trainingId: number,
    trainingTestId: number
  ) =>
    `/projects/${projectId}/products/${productId}/trainings/${trainingId}/training-tests/${trainingTestId}`,
  trainingTestSimulation: (
    projectId: number,
    productId: number,
    trainingId: number,
    trainingTestId: number,
    params: string
  ) =>
    `/projects/${projectId}/products/${productId}/trainings/${trainingId}/training-tests/${trainingTestId}/?${params}`,
  trainingTestNew: (projectId: number, productId: number, trainingId: number) =>
    `/projects/${projectId}/products/${productId}/trainings/${trainingId}/new-test`,
  settings: '/settings',
  anomalyScorePlot: (
    projectId: number,
    productId: number,
    trainingId: number,
    trainingTestId: number
  ) =>
    `/projects/${projectId}/products/${productId}/trainings/${trainingId}/training-tests/${trainingTestId}/anomaly-score-plot`,
  dataset: (projectId: number, productId: number, datasetId: number) =>
    `/projects/${projectId}/products/${productId}/images`,
}
